import React from 'react';
import { Col, FlexboxGrid, FormGroup, Icon, IconButton, SelectPicker, Tag } from 'rsuite';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import styles from './AddressRadiusFilter.module.scss';
import { AddressFilter, SelectFilterModel } from '../../types';

type AddressRadiusFilterProps = {
  endereco: AddressFilter;
  raio: SelectFilterModel;
  onChangeAddress: (value: string) => void;
  onInputChangeAddress: (value: string) => void;
  onSelectRaio: (value: string) => void;
  onCleanRaio: () => void;
  onClickRemove: () => void;
};

export const AddressRadiusFilter = ({
  endereco,
  raio,
  onChangeAddress,
  onInputChangeAddress,
  onSelectRaio,
  onCleanRaio,
  onClickRemove,
}: AddressRadiusFilterProps) => {
  return (
    <FlexboxGrid.Item componentClass={Col} lg={20} md={18} style={{ marginBottom: '0' }} xsHidden smHidden>
      <FlexboxGrid.Item componentClass={Col} lg={3} md={5}>
        <Tag className={styles.tag}>Endereço</Tag>
      </FlexboxGrid.Item>
      <FlexboxGrid.Item componentClass={Col} lg={10} md={9} style={{ marginLeft: '10px' }}>
        <FormGroup>
          <Autocomplete
            freeSolo
            disableClearable
            id="endereco"
            name="endereco"
            placeholder="Digite um endereço"
            noOptionsText="Pesquise o endereço desejado"
            options={endereco?.lista}
            value={endereco?.value || ''}
            getOptionLabel={option => (typeof option === 'string' ? option : option.label)}
            filterOptions={x => x}
            onChange={(_e, newValue) => onChangeAddress(newValue)}
            onInputChange={(_e, newInputValue) => onInputChangeAddress(newInputValue)}
            renderInput={params => <TextField {...params} margin="normal" />}
          />
        </FormGroup>
      </FlexboxGrid.Item>
      <FlexboxGrid.Item componentClass={Col} lg={2} md={2}>
        <Tag className={styles.tag}>Raio</Tag>
      </FlexboxGrid.Item>
      <FlexboxGrid.Item componentClass={Col} lg={5} md={5} style={{ marginLeft: '10px' }}>
        <SelectPicker
          block
          cleanable
          className="inf-picker"
          name="raio"
          placeholder="Selecione o alcance"
          searchable={false}
          data={raio?.lista}
          value={raio?.value}
          onSelect={onSelectRaio}
          onClean={onCleanRaio}
        />
      </FlexboxGrid.Item>
      <FlexboxGrid.Item componentClass={Col} lg={2} md={2}>
        <IconButton className={styles['delete-button']} icon={<Icon icon="trash2" />} onClick={onClickRemove} />
      </FlexboxGrid.Item>
    </FlexboxGrid.Item>
  );
};
